import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManageCustomerReviewComponent } from './manage-customer-review.component';
import { LoadingModule } from '../../../../shared/loading/loading.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [ManageCustomerReviewComponent],
  exports: [ManageCustomerReviewComponent],
  imports: [CommonModule, LoadingModule, MatSlideToggleModule],
})
export class ManageCustomerReviewModule {}
